export default __webpack_public_path__ + "static/media/typeTractor.8820ddef.svg";